/* unplugin-vue-components disabled */import script from "./FooterViews.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterViews.vue?vue&type=script&lang=ts&setup=true"

import "./FooterViews.vue?vue&type=style&index=0&id=18f0d6c4&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f0d6c4"]])

export default __exports__